// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53eb1146","453":"7895a72a","455":"0d1c62bf","977":"ee1363c5"}[chunkId] + ".chunk.js";
};